import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";
import type { Profile } from "../lib/types.js";

export function useProfiles() {
  return useQuery({
    queryKey: ["profiles"],
    queryFn: async () => {
      const { data } = await api.get<Profile[]>("/profiles");
      return data;
    },
  });
}
